import React from "react";
import { Radio, VStack } from "@chakra-ui/react";
import { RadioGroup, Form } from "components";
import { useCurrentCase } from "duck";
import {
  getDefaultValues,
  useUpdateDisclaimerProcedure,
  FormValues
} from "./duck";

const Procedures: React.FC = () => {
  const disclaimerProcedures = useCurrentCase(
    medicalCase => medicalCase.data.disclaimerProcedures
  );
  const defaultValues = getDefaultValues(disclaimerProcedures);
  const onChange = useUpdateDisclaimerProcedure();

  return (
    <Form<FormValues> defaultValues={defaultValues}>
      <Form.Watcher defaultValues={defaultValues} onChange={onChange} />
      <RadioGroup name="procedure">
        <VStack alignItems="left">
          {disclaimerProcedures.map(procedure => {
            const value = procedure._id
              ? procedure._id.toString()
              : procedure.fakeId;
            return (
              <Radio key={procedure._id || procedure.fakeId} value={value}>
                {`${procedure.title} — ${procedure.description}`}
              </Radio>
            );
          })}
        </VStack>
      </RadioGroup>
    </Form>
  );
};

export default Procedures;
